import cn from 'classnames';
import React from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import SocialIcons, {
	ISocialIconsProps,
} from 'tbk-components/src/components/SocialIcons';

export interface ISocialMediaBarProps extends IBaseElementProps {
	/**
	 * Social Media Bar Heading
	 */
	heading?: string;
	/**
	 * Social Media Bar Text
	 */
	text?: string;
	/**
	 * Social Media Social Icons
	 */
	socialIcons?: ISocialIconsProps;
}

/**
 * Follow Us
 * @block
 * @requiresHooks
 * @icon networking
 */
const SocialMediaBar: React.FC<ISocialMediaBarProps> = ({
	className,
	classNames = [],
	heading,
	text,
	socialIcons,
}) => (
	<div className={className || cn('social-media-bar', ...classNames)}>
		<div className="social-media-bar__inner">
			<div className="social-media-bar__left">
				{heading && (
					<h3 className="social-media-bar__heading">{heading}</h3>
				)}
			</div>
			<div className="social-media-bar__right">
				{socialIcons && <SocialIcons {...socialIcons} />}
			</div>
		</div>
	</div>
);

export default SocialMediaBar;
